module.exports = __webpack_public_path__ + "static/media/max3dpro_new.cbcec0a2.mp3";